query getAnalysisMetrics {
    konstantine {
        getAnalysisMetrics {
            totalCalls
            totalScheduledCalls
        }
    }
}
